export default "__VITE_ASSET__CanOjwrP__"